import ContentLoader from "react-content-loader";

const Loader = (props) => (
  <>
    <ContentLoader
      width={320}
      height={290}
      viewBox="0 0 450 400"
      backgroundColor="#f0f0f0"
      foregroundColor="#dedede"
      {...props}
    >
      <rect x="42" y="77" rx="10" ry="10" width="388" height="217" />
    </ContentLoader>
  </>
);

export default Loader;
